import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import getImagePath from '../../../CommonUtils/getImagePath';
import { selectOrgLogo } from '../../../CommonSelectors/CommonAreaSelector';

export const TopNav = () => {
  const orgLogo = useSelector(selectOrgLogo);

  return (
    <Box height="64px" display="flex" flexDirection="column" justifyContent="space-between">
      <Box px="16" py="8" display="flex">
        <img
          src={orgLogo || getImagePath('orion-planning-logo.svg')}
          css={`
            max-height: 44px;
            max-width: 600px;
            width: auto;
          `}
          alt="Logo"
        />
      </Box>
      <Box height="4px" bg="primary.500" />
    </Box>
  );
};
